import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'antd';
import { func } from 'prop-types';
import 'antd/dist/antd.dark.css';
import { userSignOut } from '../services/auth';
import { signout } from '../state/action/authAction';

const SignoutButton = ({ onSignout }) => (
  <>
    <Button
      type="link"
      onClick={() => {
        onSignout();
        userSignOut();
      }}
    >
      Sign Out
    </Button>
  </>
);

SignoutButton.propTypes = {
  onSignout: func.isRequired,
};

const mapDispatchToProps = {
  onSignout: signout,
};

export default connect(null, mapDispatchToProps)(SignoutButton);
